import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[AppErrorBoundary]", error, info);
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-crash-shell" role="alert" aria-live="assertive">
          <section className="app-crash-card">
            <span className="eyebrow">Workspace recovery</span>
            <h1>Something broke in the workspace view.</h1>
            <p>
              AddaNote could not finish rendering this screen. Reload the workspace to recover the latest saved state.
            </p>
            <button type="button" className="action-button" onClick={this.handleReload}>
              Reload workspace
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
